import { Link } from "react-router-dom";
import { ArrowRight, Heart, Smile, Gift } from "lucide-react";
import AppointmentForm from "../components/AppointmentForm";
import FAQ from "../components/FAQ";
import CTASection from "../components/CTASection";

export default function Odontopediatria() {
  const faqs = [
    { q: "¿A qué edad debe acudir mi hijo al dentista por primera vez?", a: "Se recomienda la primera visita al cumplir 1 año. En nuestra clínica la primera visita infantil es totalmente gratuita." },
    { q: "¿Tienen experiencia con niños que tienen miedo al dentista?", a: "Sí, nuestras odontopediatras están formadas en psicología infantil y manejo de la ansiedad dental. Nunca forzamos a un niño: primero confianza, luego tratamiento." },
    { q: "¿Qué tratamientos infantiles realizáis?", a: "Todos: revisiones, selladores, empastes, extracciones, ortodoncia interceptiva, traumatismos dentales, fluorización y educación en higiene oral." },
    { q: "¿Atendéis a niños con Seguridad Social (PADI)?", a: "Sí, somos clínica adherida al Programa de Atención Dental Infantil de Cataluña. Consulta las prestaciones gratuitas para tu hijo." },
  ];
  return (
    <div data-testid="odontopediatria-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
                <span className="text-xs font-semibold text-teal-700 uppercase">Odontopediatría · Calafell</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
                Dentista para <span className="underline-accent">niños</span> en Calafell
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                Especialistas en odontología infantil. Creamos una experiencia positiva desde el primer día
                para que tu hijo crezca sin miedo al dentista.
              </p>
              <Link to="/contacto" className="btn-primary" data-testid="pediatria-cta-top">
                Primera visita infantil gratis <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-slate-100">
              <h3 className="text-xl font-bold text-slate-900 mb-5">Reserva la visita de tu hijo</h3>
              <AppointmentForm defaultService="Odontopediatría (niños)" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-max">
          <div className="max-w-3xl mb-14">
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">Una experiencia positiva desde el primer día</h2>
            <p className="text-lg text-slate-600">Nuestro enfoque con los peques marca la diferencia.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: Heart, title: "Paciencia infinita", desc: "Dedicamos el tiempo que cada niño necesita. Sin prisas, sin presión." },
              { icon: Smile, title: "Juegos y recompensas", desc: "Convertimos la visita en una experiencia divertida con pequeños detalles." },
              { icon: Gift, title: "Primera visita gratis", desc: "Revisión completa y consejos de higiene sin coste alguno." },
            ].map((item, i) => (
              <div key={i} className="bg-teal-50 rounded-3xl p-8" data-testid={`pediatria-benefit-${i}`}>
                <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center mb-5">
                  <item.icon className="w-5 h-5 text-teal-700" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FAQ items={faqs} title="Preguntas frecuentes de padres" />
      <CTASection />
    </div>
  );
}
